import { combineReducers } from "redux";
import rfrNoticesReducer from "./rfrNoticesReducer";
import fileRfrReducer from "./fileRfrReducer";
import submitRfrReducer from "./submitRfrReducer";

const rfrReducer = combineReducers({
    getnotices: rfrNoticesReducer,
    filerfr: fileRfrReducer,
    submitrfr: submitRfrReducer
});

export default rfrReducer;